import React from 'react'
import { Grid, Typography, TextField, FormControl, FormLabel, FormControlLabel, RadioGroup, Radio, Divider } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import SaveIcon from '@material-ui/icons/Save'

import { Header, Page, CustomButton, SecaoGenerica } from 'components'
import { useStyles } from './InformacaoSINAB.styles'
import { useInformacaoSINAB } from './hooks/useInformacaoSINAB'

export const InformacaoSINAB = (props) => {
  const { route } = props
  const classes = useStyles()

  const {
    processando,
    formState,
    isValid,
    handleChange,
    handleLaudoChange,
    handleFinalizarExame,
    router,
  } = useInformacaoSINAB()

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />


      <Grid item container spacing={2} sm={12} xs={12} md={12}>
        <Grid item style={{ marginTop: 16 }} sm={12} xs={12} md={4}>
          <FormControl component="fieldset" fullWidth className={classes.radio}>
            <FormLabel id="num-ligacoes" component={Typography} required>
              NÚMERO DE LIGAÇÕES
            </FormLabel>
            <RadioGroup
              aria-labelledby="num-ligacoes"
              name="numLigacoes"
              value={formState.numLigacoes || '0'}
              onChange={handleChange}
              style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}
            >
              <FormControlLabel value="0" control={<Radio />} label={<Typography variant="body2">0</Typography>} />
              <FormControlLabel value="1" control={<Radio />} label={<Typography variant="body2">1</Typography>} />
              <FormControlLabel value="2" control={<Radio />} label={<Typography variant="body2">2+</Typography>} />
            </RadioGroup>
          </FormControl>
        </Grid>

        {formState.numLigacoes !== '0' && (
          <Grid item style={{ marginTop: 16, marginBottom: 16 }} sm={12} xs={12} md={4}>
            <TextField
              variant="outlined"
              label="LAUDO DE COINCIDÊNCIA DE PERFIS BALÍSTICOS"
              required
              fullWidth
              value={formState.numLaudo}
              InputLabelProps={{
                shrink: true,
              }}
              className={classes.input}
              name="numLaudo"
              inputProps={{ maxLength: 12 }}
              onChange={handleLaudoChange}
              placeholder="CP-FFFF-0000"
              disabled={formState.numLigacoes === '0'}
            />
          </Grid>
        )}
      </Grid>

      <Grid item xs={12}>
        <Divider />
      </Grid>


      <Grid container justifyContent="space-between" className={classes.botoesFormulario}>
        <Grid item>
          <CustomButton
            variant="outlined"
            onClick={() => router.history.goBack()}
            startIcon={<ArrowBackIcon />}
          >
            Voltar
          </CustomButton>
        </Grid>
        <Grid item>
          <CustomButton
            variant="contained"
            color="primary"
            disabled={!isValid}
            isLoading={processando}
            onClick={handleFinalizarExame}
            startIcon={<SaveIcon />}
          >
            Finalizar
          </CustomButton>
        </Grid>
      </Grid>

    </Page>
  )
}
